import styled from 'styled-components'

export const BenefitContainer = styled.div`
  max-width: 449.33px;
  width: 100%;
  min-height: 132px;
  padding: 20px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => theme.fixedPanelBg};
`

export const BenefitImage = styled.img`
  ${({ theme }) => theme.mediaWidth.upToMedium`
    transform: scale(0.7);
  `}
`

export const BenefitTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 327px;
`

export const BenefitTitle = styled.h3`
  font-size: 24px;
  font-weight: 500;
  line-height: 31px;
  margin: 0 0 10px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 18px;
    line-height: 23px;
    margin: 0 0 5px;
  `}
`

export const BenefitDescription = styled.p`
  font-size: 13px;
  font-weight: 400;
  line-height: 17px;
  color: ${({ theme }) => theme.accentText};
  margin: 0;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 12px;
    line-height: 16px; 
  `}
`
